(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     Reveals al hacer scroll
     --------------------------------------------------------------------- */
  function initReveals() {
    var els = document.querySelectorAll('.duma-reveal');
    if (!els.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('duma-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('duma-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------------------------------------------------------------
     Parallax sutil al mover el mouse
     --------------------------------------------------------------------- */
  function initParallax() {
    if (prefersReducedMotion) return;
    var zones = document.querySelectorAll('[data-duma-parallax-zone]');
    if (!zones.length) return;

    zones.forEach(function (zone) {
      var targets = zone.querySelectorAll('.duma-parallax');
      if (!targets.length) return;
      var raf = null;

      zone.addEventListener('mousemove', function (e) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          var rect = zone.getBoundingClientRect();
          var relX = (e.clientX - rect.left) / rect.width - 0.5;
          var relY = (e.clientY - rect.top) / rect.height - 0.5;

          targets.forEach(function (t) {
            var intensity = parseFloat(t.getAttribute('data-duma-intensity') || '14');
            t.style.setProperty('--duma-mx', (relX * intensity).toFixed(2));
            t.style.setProperty('--duma-my', (relY * intensity).toFixed(2));
          });
          raf = null;
        });
      });

      zone.addEventListener('mouseleave', function () {
        targets.forEach(function (t) {
          t.style.setProperty('--duma-mx', 0);
          t.style.setProperty('--duma-my', 0);
        });
      });
    });
  }

  /* ---------------------------------------------------------------------
     Cifras animadas (count-up) al entrar en pantalla
     --------------------------------------------------------------------- */
  function initContadores() {
    var els = document.querySelectorAll('.duma-cifra[data-duma-hasta]');
    if (!els.length) return;

    function anima(el) {
      var hasta = parseFloat(el.getAttribute('data-duma-hasta')) || 0;
      var duracion = 1400;
      var inicio = null;

      if (prefersReducedMotion) {
        el.textContent = hasta;
        return;
      }

      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var ease = 1 - Math.pow(1 - progreso, 3);
        el.textContent = Math.round(hasta * ease);
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(anima);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            anima(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------------------------------------------------------------
     FAQ acordeón
     --------------------------------------------------------------------- */
  function initFaq() {
    var items = document.querySelectorAll('.duma-faq-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var boton = item.querySelector('.duma-faq-pregunta');
      var respuesta = item.querySelector('.duma-faq-respuesta');
      if (!boton || !respuesta) return;

      boton.addEventListener('click', function () {
        var abierto = item.getAttribute('data-abierto') === 'true';

        items.forEach(function (otro) {
          if (otro !== item) {
            otro.setAttribute('data-abierto', 'false');
            otro.querySelector('.duma-faq-respuesta').style.maxHeight = 0;
            otro.querySelector('.duma-faq-pregunta').setAttribute('aria-expanded', 'false');
          }
        });

        if (abierto) {
          item.setAttribute('data-abierto', 'false');
          respuesta.style.maxHeight = 0;
          boton.setAttribute('aria-expanded', 'false');
        } else {
          item.setAttribute('data-abierto', 'true');
          respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
          boton.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------------------------------------------------------------------
     Suaviza el scroll a los anclas internas (p. ej. "Elige tu etapa")
     --------------------------------------------------------------------- */
  function initAnclas() {
    document.querySelectorAll('a[href^="#duma-"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var destino = document.querySelector(link.getAttribute('href'));
        if (!destino) return;
        e.preventDefault();
        destino.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initParallax();
    initContadores();
    initFaq();
    initAnclas();
  });
})();
